import {css, cx} from "@panda/css";
import {useGoogleLogin} from "@react-oauth/google";

import {Text} from "@pg-design/text-module";
import {pick} from "@pg-mono/nodash";

import {facebookAppId} from "../../../app/read_rp_environment_variables";
import {notifyBugsnag} from "../../../errors/bugsnag/notify_bugsnag";
import {addNotification} from "../../../notifications/state/notifications_slice";
import {useAppDispatch} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {authSucceeded} from "../../actions/auth_succeeded_event";
import {facebookAuth, googleAuth} from "../../api/social_auth";
import {authAnalytics, GAAuthEventCategory, GAAuthEventName} from "../../tracking/auth_analytics";
import {AuthActionType} from "../../types/AuthActionType";
import type {IFacebookResponse} from "../../types/IFacebookResponse";
import {GOOGLE_OAUTH_SCOPE} from "../../utils/social_auth_config";
import {FacebookAuth} from "./FacebookAuth";

const facebookIcon = require("../../images/facebook_icon.svg");
const googleIcon = require("../../images/google_icon.svg");

interface IProps {
    className?: string;
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
}

export const SocialAuth = (props: IProps) => {
    const dispatch = useAppDispatch();

    const onGoogleLogin = useGoogleLogin({
        onError: () => {
            dispatch(addNotification({notification: {type: "failure", content: "Coś poszło nie tak. Spróbuj później."}}));
        },
        onNonOAuthError: async (error) => {
            if (error.type === "popup_closed") {
                return;
            }
            dispatch(addNotification({notification: {type: "failure", content: "Coś poszło nie tak. Spróbuj później."}}));
        },
        onSuccess: (response) => {
            if (response.access_token) {
                googleAuth(response.access_token).then(async (authResponse) => {
                    const isNewUser = authResponse.is_new;

                    if (typeof isNewUser !== "boolean") {
                        notifyBugsnag(new Error("Problem with social auth response"), "Problem with is_new type in Google Auth response", {
                            ...pick(authResponse, ["type", "login_method", "is_new"])
                        });
                    }

                    authAnalytics.gtm.googleAuthEvent({
                        event: isNewUser ? GAAuthEventName.SIGN_UP : GAAuthEventName.LOGIN,
                        eventCategory: isNewUser ? GAAuthEventCategory.REGISTRATION_FORM : GAAuthEventCategory.LOGIN_FORM,
                        source: props.gtmSourceSection ?? null,
                        userSource: props.userSource
                    });

                    dispatch(
                        authSucceeded({
                            type: isNewUser ? AuthActionType.REGISTRATION : AuthActionType.LOGIN,
                            userSource: props.userSource,
                            gtmSourceSection: props.gtmSourceSection,
                            registrationMethod: "social",
                            socialMediaType: "google"
                        })
                    );

                    props.onAuthSuccess(isNewUser ? AuthActionType.REGISTRATION : AuthActionType.LOGIN);
                });
            }
        },
        scope: GOOGLE_OAUTH_SCOPE
    });

    const facebookResponse = (response: IFacebookResponse) => {
        facebookAuth(response.accessToken).then(async (authResponse) => {
            const isNewUser = authResponse.is_new;

            if (typeof isNewUser !== "boolean") {
                notifyBugsnag(new Error("Problem with social auth response"), "Problem with is_new type in Facebook Auth response", {
                    ...pick(authResponse, ["type", "login_method", "is_new"])
                });
            }

            authAnalytics.gtm.facebookAuthEvent({
                event: isNewUser ? GAAuthEventName.SIGN_UP : GAAuthEventName.LOGIN,
                eventCategory: isNewUser ? GAAuthEventCategory.REGISTRATION_FORM : GAAuthEventCategory.LOGIN_FORM,
                source: props.gtmSourceSection ?? null,
                userSource: props.userSource
            });

            dispatch(
                authSucceeded({
                    type: isNewUser ? AuthActionType.REGISTRATION : AuthActionType.LOGIN,
                    userSource: props.userSource,
                    gtmSourceSection: props.gtmSourceSection,
                    registrationMethod: "social",
                    socialMediaType: "facebook"
                })
            );

            props.onAuthSuccess(isNewUser ? AuthActionType.REGISTRATION : AuthActionType.LOGIN);
        });
    };

    return (
        <div className={cx(socialAuth, props.className)}>
            {!!facebookAppId && (
                <div className={facebook}>
                    <div className={button}>
                        <img src={facebookIcon} alt="fb" /> <Text variant="info_txt_1">Kontynuuj z Facebook</Text>
                        <FacebookAuth appId={facebookAppId as string} buttonText=" " className="facebookAuthButton" callback={facebookResponse} />
                    </div>
                </div>
            )}

            <div>
                <div className={button} onClick={() => onGoogleLogin()}>
                    <img src={googleIcon} alt="gl" /> <Text variant="info_txt_1">Kontynuuj z Google</Text>
                </div>
            </div>
        </div>
    );
};

const socialAuth = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1.5
});

const facebook = css({
    "& .facebookAuthButton": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",

        "&:focus, &:focus:active": {
            border: "none",
            outline: 0
        }
    }
});

const button = css({
    backgroundColor: "var(--colors-gray-100)",
    paddingY: 1,
    paddingX: 2,
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    columnGap: 2,
    position: "relative"
});
import {css, cx} from "@panda/css";
import {useGoogleLogin} from "@react-oauth/google";

import {Text} from "@pg-design/text-module";
import {pick} from "@pg-mono/nodash";

import {facebookAppId} from "../../../app/read_rp_environment_variables";
import {notifyBugsnag} from "../../../errors/bugsnag/notify_bugsnag";
import {addNotification} from "../../../notifications/state/notifications_slice";
import {useAppDispatch} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {authSucceeded} from "../../actions/auth_succeeded_event";
import {facebookAuth, googleAuth} from "../../api/social_auth";
import {authAnalytics, GAAuthEventCategory, GAAuthEventName} from "../../tracking/auth_analytics";
import {AuthActionType} from "../../types/AuthActionType";
import type {IFacebookResponse} from "../../types/IFacebookResponse";
import {GOOGLE_OAUTH_SCOPE} from "../../utils/social_auth_config";
import {FacebookAuth} from "./FacebookAuth";

const facebookIcon = require("../../images/facebook_icon.svg");
const googleIcon = require("../../images/google_icon.svg");

interface IProps {
    className?: string;
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
}

export const SocialAuth = (props: IProps) => {
    const dispatch = useAppDispatch();

    const onGoogleLogin = useGoogleLogin({
        onError: () => {
            dispatch(addNotification({notification: {type: "failure", content: "Coś poszło nie tak. Spróbuj później."}}));
        },
        onNonOAuthError: async (error) => {
            if (error.type === "popup_closed") {
                return;
            }
            dispatch(addNotification({notification: {type: "failure", content: "Coś poszło nie tak. Spróbuj później."}}));
        },
        onSuccess: (response) => {
            if (response.access_token) {
                googleAuth(response.access_token).then(async (authResponse) => {
                    const isNewUser = authResponse.is_new;

                    if (typeof isNewUser !== "boolean") {
                        notifyBugsnag(new Error("Problem with social auth response"), "Problem with is_new type in Google Auth response", {
                            ...pick(authResponse, ["type", "login_method", "is_new"])
                        });
                    }

                    authAnalytics.gtm.googleAuthEvent({
                        event: isNewUser ? GAAuthEventName.SIGN_UP : GAAuthEventName.LOGIN,
                        eventCategory: isNewUser ? GAAuthEventCategory.REGISTRATION_FORM : GAAuthEventCategory.LOGIN_FORM,
                        source: props.gtmSourceSection ?? null,
                        userSource: props.userSource
                    });

                    dispatch(
                        authSucceeded({
                            type: isNewUser ? AuthActionType.REGISTRATION : AuthActionType.LOGIN,
                            userSource: props.userSource,
                            gtmSourceSection: props.gtmSourceSection,
                            registrationMethod: "social",
                            socialMediaType: "google"
                        })
                    );

                    props.onAuthSuccess(isNewUser ? AuthActionType.REGISTRATION : AuthActionType.LOGIN);
                });
            }
        },
        scope: GOOGLE_OAUTH_SCOPE
    });

    const facebookResponse = (response: IFacebookResponse) => {
        facebookAuth(response.accessToken).then(async (authResponse) => {
            const isNewUser = authResponse.is_new;

            if (typeof isNewUser !== "boolean") {
                notifyBugsnag(new Error("Problem with social auth response"), "Problem with is_new type in Facebook Auth response", {
                    ...pick(authResponse, ["type", "login_method", "is_new"])
                });
            }

            authAnalytics.gtm.facebookAuthEvent({
                event: isNewUser ? GAAuthEventName.SIGN_UP : GAAuthEventName.LOGIN,
                eventCategory: isNewUser ? GAAuthEventCategory.REGISTRATION_FORM : GAAuthEventCategory.LOGIN_FORM,
                source: props.gtmSourceSection ?? null,
                userSource: props.userSource
            });

            dispatch(
                authSucceeded({
                    type: isNewUser ? AuthActionType.REGISTRATION : AuthActionType.LOGIN,
                    userSource: props.userSource,
                    gtmSourceSection: props.gtmSourceSection,
                    registrationMethod: "social",
                    socialMediaType: "facebook"
                })
            );

            props.onAuthSuccess(isNewUser ? AuthActionType.REGISTRATION : AuthActionType.LOGIN);
        });
    };

    return (
        <div className={cx(socialAuth, props.className)}>
            {!!facebookAppId && (
                <div className={facebook}>
                    <div className={button}>
                        <img src={facebookIcon} alt="fb" /> <Text variant="info_txt_1">Kontynuuj z Facebook</Text>
                        <FacebookAuth appId={facebookAppId as string} buttonText=" " className="facebookAuthButton" callback={facebookResponse} />
                    </div>
                </div>
            )}

            <div>
                <div className={button} onClick={() => onGoogleLogin()}>
                    <img src={googleIcon} alt="gl" /> <Text variant="info_txt_1">Kontynuuj z Google</Text>
                </div>
            </div>
        </div>
    );
};

const socialAuth = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1.5
});

const facebook = css({
    "& .facebookAuthButton": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",

        "&:focus, &:focus:active": {
            border: "none",
            outline: 0
        }
    }
});

const button = css({
    backgroundColor: "var(--colors-gray-100)",
    paddingY: 1,
    paddingX: 2,
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    columnGap: 2,
    position: "relative"
});
